import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldDateTimeComponent } from './field-date-time.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';



@NgModule({
  declarations: [
    FieldDateTimeComponent
  ],
  exports: [
    FieldDateTimeComponent
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule
  ]
})
export class FieldDateTimeModule { }
